module.exports = __webpack_public_path__ + "img/tennisdoubles-dark.25ffc64b.svg";